import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
} from 'react'
import {
  requestAnalyticsCustomersGeneral,
  requestAnalyticsCustomersMonth,
  requestAnalyticsCustomersYear,
} from 'requests/analytics-customers'
import { SETTINGS_SUBMENU } from 'constants/menu/submenus'
import { MONTHS_OPTIONS } from 'constants/months'
import { SideMenu } from 'components/SideMenu'
import { ListPage } from 'templates/ListPage'
import { RequestButton } from 'components/RequestButton';
import { SelectForm } from 'components/Form/components'
import Table from 'ui-components/Table'
import { currencyFormat } from 'utils/format'
import styled from '@emotion/styled'

const INITIAL_YEAR = 2020
const TABLE_HEADER = ['Cliente', 'Compras', 'Pagamentos']

const SearchForm = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 35% 35% 10%;

  button {
    margin-top: 15px;
  }
`

export default function PurchasesPayments() {
  const [list, setList] = useState([])
  const [pagination, setPagination] = useState()
  const [year, setYear] = useState()
  const [yearOption, setYearOption] = useState({})
  const [month, setMonth] = useState()
  const [monthOption, setMonthOption] = useState({})
  const [loading, setLoading] = useState(false)
  const page = useRef()

  const months = MONTHS_OPTIONS

  const requestAnalyticsCustomers = useCallback(async () => {
    setLoading(true)
    const response = await requestAnalyticsCustomersGeneral({})
    setList(response.data)
    setPagination(response.meta.pagination)
    setLoading(false)
  }, [])

  useEffect(() => {
    setLoading(true)
    requestAnalyticsCustomers()
  }, [requestAnalyticsCustomers])

  const getYearsOptions = () => {
    const currentYear = new Date().getFullYear()
    let initialYear = INITIAL_YEAR
    const years = []

    while (initialYear <= currentYear) {
      years.push({ value: initialYear, label: initialYear })
      initialYear += 1
    }

    return years
  }

  const getColumns = () => (
    list.map((item, index) => ([
      {
        id: `${index}-customer`,
        style: {},
        value: item.attributes.customer.name,
      },
      {
        id: `${index}-purchased`,
        style: { textAlign: 'right' },
        value: currencyFormat(item.attributes.total_purchased),
      },
      {
        id: `${index}-paid`,
        style: { textAlign: 'right' },
        value: currencyFormat(item.attributes.total_paid),
      },
    ]))
  )

  const renderMenu = () => (
    <SideMenu submenu={SETTINGS_SUBMENU} />
  )

  const onChangeMonth = (e) => {
    setMonth(e.value)
    setMonthOption(e)
  }

  const onChangeYear = (e) => {
    setYear(e.value)
    setYearOption(e)
  }

  const requestSearch = async () => {
    const params = {
      year,
      month,
      page: page.current,
    }

    if (!year && !month) {
      return requestAnalyticsCustomersGeneral(params)
    }

    if (year && month) {
      return requestAnalyticsCustomersMonth(params)
    }

    if (year) {
      return requestAnalyticsCustomersYear(params)
    }

    return null
  }

  const onSearch = async () => {
    if (!year && Boolean(month)) return null

    setLoading(true)
    const response = await requestSearch()

    setList(response.data)
    setPagination(response.meta.pagination)
    return setLoading(false)
  }

  const onRequestSearch = () => {
    page.current = null
    onSearch()
  }

  const onClickPagination = (selectedPage) => {
    if (selectedPage === page.current) return

    page.current = selectedPage
    onSearch()
  }

  const renderSearchForm = () => (
    <SearchForm>
      <SelectForm
        name="month"
        options={months}
        value={monthOption || {}}
        label="Mês"
        onChange={onChangeMonth}
      />

      <SelectForm
        name="year"
        options={getYearsOptions()}
        value={yearOption || {}}
        label="Ano"
        onChange={onChangeYear}
      />

      <div>
        <RequestButton
          onClick={onRequestSearch}
          color="primary"
          loading={loading}
          text="Buscar"
        />
      </div>
    </SearchForm>
  )

  return (
    <ListPage
      renderForm={() => (<div>Form</div>)}
      renderMenu={renderMenu}
      listTitle="Lista de pedidos"
      onClickPagination={onClickPagination}
      pagination={pagination}
      loading={loading}
      onToggleForm={() => {}}
      renderSearchForm={renderSearchForm}
      openSearchForm
    >
      <div>
        <Table data={TABLE_HEADER} columns={getColumns()} />
      </div>
    </ListPage>
  )
}
